import { useQuery } from '../../../hooks';

import * as connectionsService from '../service';
import { ConnectionCacheKeys } from '../consts';

export const useConnectionTypes = () => {
  const getConnectionTypes = useQuery({
    queryFn: connectionsService.getConnectionTypes,
    queryKey: [ConnectionCacheKeys.GetConnectionTypes],
  });

  return {
    getConnectionTypes,
  };
};
